import { isEmpty } from '@ember/utils';
import PeopleSchemaAdapter from './base';

export default class Field extends PeopleSchemaAdapter {
  modelNamePlural = 'fields';

  queryRecord(store, model, query) {
    if (!isEmpty(query.jurisdictionalId)) {
      let url = this.buildURL(
        model.modelName,
        'jurisdictionalId',
        null,
        'findRecord',
      );
      return this.ajax(url, 'GET', {});
    }
    return super.queryRecord(...arguments);
  }
}
